<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>反算管理</el-breadcrumb-item>
      <el-breadcrumb-item>反算平账</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search" @submit.native.prevent>
      <el-form-item v-if="user.username == 'admin'" label="部门">

        <el-select v-model="formInline.departmentId" placeholder="请选择" @change="changeDept" size="small">
          <el-option v-for="item in deptData" :key="item.id" :label="item.departmentName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="搜索：">
        <el-input size="small" @keyup.enter.native="search" v-model="formInline.meterPointName" placeholder="请输入计量点名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" @keyup.enter.native="search" v-model="formInline.appletUserNames" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" @keyup.enter.native="search" v-model="formInline.contractNo" placeholder="请输入合同编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
       <!-- <prems-button size="small" type="primary" icon="el-icon-circle-plus-outline" perms="rule:add" @click="handleEdit()"
          label="添加" /> -->

      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;" stripe :header-cell-style="this.$store.state.headerCss">
      <el-table-column align="center" type="index" width="60" label="序号">
      </el-table-column>
      <el-table-column prop="meterPointName" label="计量点" >
      </el-table-column>
      <el-table-column prop="meterPoint" label="计量点地址" >
      </el-table-column>
      <el-table-column prop="appletUserNames" label="用户名" >
      </el-table-column>
      <el-table-column prop="contractNo" label="合同编号" >
      </el-table-column>
      <el-table-column prop="blance" label="余额(元)" >
      </el-table-column>



      <el-table-column align="center" label="操作" width="160">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
          <!-- <el-button size="mini" type="primary" @click="handleSet(scope.$index, scope.row)">平账</el-button> -->
           <prems-button  perms="pre:pz" label="平账"  size="small" type="primary"  @click="handleSet(scope.$index, scope.row)" />
          <!-- <el-button size="mini" type="danger"  @click="deleteInfo(scope.$index, scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <Pagination v-bind:child-msg="formInline" @callFather="callFather" v-if="showPage" ></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%">
      <el-form label-width="68px" :model="editForm" :rules="rules" ref="editForm" style="padding: 0 30px;">



        <el-form-item label="金额" prop="money">
          <el-input size="small" disabled v-model="editForm.money" auto-complete="off" placeholder="请输入需要平账的金额"></el-input>
        </el-form-item>
        <el-form-item label="交易类型" prop="isRecharge">
          <el-select disabled v-model="editForm.isRecharge" size="small" placeholder="请选择" style="width:100%">
            <el-option label="充值" value="1"></el-option>
            <el-option label="扣费" value="2"></el-option>
            <el-option label="退款" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易方式" prop="payType">
          <el-select v-model="editForm.payType" size="small" placeholder="请选择" style="width:100%">
            <el-option v-for="item in payType" :label="item.label" :value="item.value"></el-option>

          </el-select>
        </el-form-item>

        <el-form-item label="备注" prop="mark">
          <el-input size="small" v-model="editForm.mark" auto-complete="off" placeholder="请输入备注"></el-input>
        </el-form-item>



      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" :loading="loadingSave" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>






  </div>
</template>
<script>
  import PremsButton from "@/views/permission/PreButtom";
  import Pagination from '../../components/Pagination'
  import {
    mapState
  } from 'vuex'
  import {


    findBalDataList,
    addBalanceData
  } from '../../api/payMG.js'
  import {
    getDepartmentTerminalInfoLis
  } from '../../api/energyMG'
  var p1 = [{
      value: '2',
      label: "转账"
    },
    {
      value: '3',
      label: "刷卡"
    },
    {
      value: '7',
      label: "多还少补"
    },
    {
      value: '6',
      label: "其他"
    },
    {
      value: '1',
      label: "现金"
    },
    {
      value: '4',
      label: "支付宝"
    },
    {
      value: '5',
      label: "微信"
    },
  ]
  var p2 = [{
      value: '2',
      label: "转账发票"
    },
    {
      value: '3',
      label: "刷卡发票"
    },
    {
      value: '7',
      label: "多还少补"
    },
    {
      value: '6',
      label: "其他"
    },
    {
      value: '1',
      label: "现金发票"
    },
    {
      value: '4',
      label: "支付宝发票"
    },
    {
      value: '5',
      label: "微信发票"
    },
  ]
  export default {

    data() {
      var checkPrice = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('水价不能为空'));
        }
        setTimeout(() => {
          if (value <= 0) {
            callback(new Error('水价不能小于或者等于0'));
          } else {
            callback();
          }
        }, 1000);
      };
      return {
        formInline: {
          meterPoint: '',
          meterPointName: '',
          appletUserNames: "",
          departmentId: "",
          contractNo: "",
          pageSize: 10,
          currentPage: 1,
          total:0
        },
        showPage:true,
        showBindMeter: false,
        loadMeter: false,
        totalCount: 0,
        terDatas: [],
        user: {},
        depId: "",
        editForm: {
          historyId: "",
          money: '',
          isRecharge: '1',
          payType: '2',
          mark: ""
        },
        nmsg: [],
        terIds: [],
        meterName: "",
        deptData: [],
        editFormVisible: false,
        setFormVisible: false,
        title: '添加',
        dataList: [],
        tempDelMeterList: [],
        pageForm: {
          currentPage: 1,
          pageSize: 50
        },
        loadingSave: false,
        meterList: [],
        addFormVisible: false,
        loading: false,
        setLoading: false,
        selectList: [],
        rules: {

          priceName: [{
            required: true,
            message: '请输入水价名称',
            trigger: 'blur'
          }],
          price: [{
            validator: checkPrice,
            trigger: 'blur'
          }]

        },
        payType: [],


      }
    },


    created() {
      this.user = JSON.parse(sessionStorage.getItem('userdata'))

      this.getJzData()


    },

    computed: {
      tables() {
        let search = this.searchDatas
        if (search) {
          return this.MeterInfoList.filter(data => {
            return Object.keys(data).some(key => {
              return String(data[key]).toLowerCase().indexOf(search) > -1
            })
          })
        }
        return this.MeterInfoList
      },
      ...mapState({
        energyConfig: 'energyConfig'
      })
    },
    methods: {
      changeDept(e) {

        // this.terIds = []

        // this.terIds = this.deptData.filter(item => item.id == e)[0].terminalInfo.map(item => item.id)
        // this.terDatas = this.deptData.filter(item => item.id == e)[0].terminalInfo

        // this.pageForm.currentPage = 1
        // this.pageForm.pageSize = 50
        // this.getMeterInfoList()
        this.search()
      },



      handleSizeChange(val) {

        this.pageForm.pageSize = val
        this.getMeterInfoList();
      },

      handleCurrentChange(e) {

        this.pageForm.currentPage = e
        this.getMeterInfoList();
      },

      //获取部门信息
      getJzData: function() {
        this.loading = true
        getDepartmentTerminalInfoLis().then(res => {

          if (res.status == 1) {
            this.deptData = res.data.menuDepList

            this.formInline.departmentId = res.data.menuDepList[0].id

            if (this.formInline.departmentId == 101) {
              this.payType = p1
            } else {
              this.payType = p2
            }
            this.getdata()


          } else {
            this.$message.error(res.msg)
          }
        })
      },






      // 分页插件事件
      callFather(parm) {
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },

      changeType(e) {
        this.editForm.powerType = e
        this.getdata()
      },
      // 搜索事件
      search() {
        this.formInline.currentPage = 1
        this.showPage = false

        this.getdata()
        this.$nextTick( () => {
          this.showPage = true
        })
      },
      //显示编辑界面
      handleEdit: function(index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '修改'
          this.editForm.id = row.id
          this.editForm.month = row.month
          this.editForm.price = row.price
          this.editForm.powerType = parseInt(row.powerType)
          this.editForm.priceName = row.priceName
        } else {
          this.title = '添加'
          this.editForm.id = ""
          this.editForm.month = ''
          this.editForm.price = ''
          this.editForm.priceName = ''
        }
      },

      //设置弹窗
      handleSet(index, row) {
        this.editFormVisible = true
        this.editForm.historyId = row.id
        this.editForm.money =  Math.abs(row.blance)
        this.editForm.mark = '平账操作'
        if(row.blance > 0){
          this.editForm.isRecharge = '3'
        }else{
          this.editForm.isRecharge = '1'
        }

      },

      getDelMeterIds(e) {
        this.tempDelMeterList = e.map(item => item.id)
      },





      // 编辑、添加提交方法
      submitForm(editData) {

        // this.$refs[editData].validate(valid => {
        // 	if (valid) {
        // 		if (this.title == '添加') {
        // 			this.add();
        // 		} else {
        // 			this.update();
        // 		}

        // 	}
        // })
        this.saveBalanceData()
      },

      saveBalanceData() {
        this.loadingSave = true
        addBalanceData(this.editForm)
          .then(res => {
            this.loadingSave = false
            if (res.status == 1) {
              this.getdata()
              this.editFormVisible = false
              this.$message({
                type: 'success',
                message: '操作成功！'
              })
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
      },



      getdata() {
        this.loading = true
        findBalDataList(this.formInline).then(res => {
            this.loading = false
            if (res.status == 1) {
              this.dataList = res.data.data

              this.formInline.total = res.data.totalCount

            } else {
              this.loading = false
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          
      },
      add() {

        this.loadingSave = true
        addInverseRule(this.editForm)
          .then(res => {
            this.loadingSave = false
            if (res.status == 1) {
              this.getdata(this.formInline)
              this.editFormVisible = false
              this.$message({
                type: 'success',
                message: '添加成功！'
              })
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })

      },
      update() {
        this.loadingSave = true
        updateInverseRule(this.editForm)
          .then(res => {
            this.loadingSave = false
            if (res.status == 1) {
              this.editFormVisible = false
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: '操作成功！'
              })
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })

      },
      // 删除
      deleteInfo(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            // 删除
            deleteInverseRule({
                id: row.id
              })
              .then(res => {
                if (res.status == 1) {
                  this.$message({
                    type: 'success',
                    message: '已删除!'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'error',
                    message: res.msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('删除失败，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除！'
            })
          })
      },


      getMeterInfoList() {
        this.loadMeter = true
        let param = {
          meterName: this.meterName,
          energyType: this.formInline.powerType,
          priceId: this.curPriceId,
          terInfoIds: this.terIds.join('-'),
          currentPage: this.pageForm.currentPage,
          pageSize: this.pageForm.pageSize

        }
        findAllMeterInfoListByPriceId(param).then(res => {
            this.loadMeter = false
            if (res.status == 1) {

              this.MeterInfoList = res.data
              this.meterList = res.data.data
              this.totalCount = res.data.totalCount
              //this.setChoisMeter(row)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loadMeter = false
            this.$message.error('获取数据失败，请稍后再试！')
          })

      },
      getAddMeterIds(e) {
        this.tempAddMeterList = e
      },

      addMeters() {
        let arr = this.selectList.concat(this.tempAddMeterList)
        //	this.selectList = Array.from(new Set(arr))
        let find = []
        arr.forEach(item => {
          if (!find.find(e => e.id == item.id)) {
            find.push(item)
          }
        })
        this.selectList = find








        console.log(this.selectList)
        this.addFormVisible = false
        this.tempAddMeterList = []

        this.$refs.bindTable.clearSelection();

      },
      mSearch() {
        this.pageForm.currentPage = 1
        this.getMeterInfoList()
      },

      subBindMeter() {
        let currMeterIds = this.selectList.map(item => item.id).join('-')
        let param = {
          priceId: this.curPriceId,
          meterInfoIds: currMeterIds
        }
        //检查计量点是否已经绑定了其他价格
        checkPriceBindMeterInfo(param).then(res => {
          if (res.status == 1) {
            this.bindMeter(param)
          } else {
            this.nmsg = res.msg.split(',')
            this.showBindMeter = true
            // this.$confirm(nmsg, '信息', {
            // 	confirmButtonText: '确定',
            // 	cancelButtonText: '取消',
            // 	type: 'warning'
            // }).then(() => {
            // 	this.bindMeter(param)
            // })
          }
        })
      },
      bindMeter() {
        this.setLoading = true
        let currMeterIds = this.selectList.map(item => item.id).join('-')
        let param = {
          priceId: this.curPriceId,
          meterInfoIds: currMeterIds
        }
        priceBindMeterInfo(param)
          .then(res => {
            this.setLoading = false
            this.setFormVisible = false

            if (res.status == 1) {
              this.$message({
                type: 'success',
                message: '操作成功！'
              })
              this.showBindMeter = false
              this.getdata()
              // this.$store.dispatch('getSendMsg')
              //this.meterPointName = ""

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.setFormVisible = false
            this.setLoading = false
            this.$message.error('操作失败，请稍后再试！')
          })
      },


    },
    components: {

      PremsButton,
      Pagination
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/prepayment/fsPz.vue